var $ = jQuery;

import { Autoplay } from 'swiper/modules';
import { carousel } from '../lib/carousel.js';

// Guest reviews on the home page: horizontal on phones, vertical from lg.
// The auto-scroll pauses while the reviews are hovered or focused, stops for
// good once someone uses the controls, can be paused with its own button, and
// never starts for visitors who ask for reduced motion.
$(document).on('ready', function(){
    $('.customer-swiper').each(function(){
      var scope = this.parentElement;
      var pauseButton = scope.querySelector('[data-carousel-pause]');
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      var swiper = carousel(this, scope, {
        label: 'review',
        modules: [Autoplay],
        loop: true,
        // A vertical loop has no edge to hand the wheel back to the page at, so
        // the wheel stays off rather than trapping the page scroll
        mousewheel: false,
        direction: 'horizontal',
        slidesPerView: 1.1,
        spaceBetween: 20,
        speed: 800,
        autoplay: reduceMotion ? false : { delay: 5000, pauseOnMouseEnter: true, disableOnInteraction: false },
        breakpoints: {
          500: { slidesPerView: 2 },
          1024: { slidesPerView: 'auto', direction: 'vertical', autoHeight: true },
        },
      });

      if (!pauseButton) {
        return;
      }

      if (reduceMotion) {
        pauseButton.classList.add('hidden');
        return;
      }

      var stopped = false;

      function setStopped(value) {
        stopped = value;
        pauseButton.setAttribute('aria-pressed', value ? 'true' : 'false');
        pauseButton.setAttribute('aria-label', value ? 'Play reviews' : 'Pause reviews');
        pauseButton.querySelector('[data-icon-pause]').classList.toggle('hidden', value);
        pauseButton.querySelector('[data-icon-play]').classList.toggle('hidden', !value);
      }

      pauseButton.addEventListener('click', function(){
        if (stopped) {
          swiper.autoplay.start();
          swiper.autoplay.resume();
          setStopped(false);
        } else {
          swiper.autoplay.stop();
          setStopped(true);
        }
      });

      // Using the arrows, the keys or a swipe means the visitor is reading
      swiper.on('navigationNext navigationPrev keyPress sliderFirstMove', function(){
        if (!stopped) {
          swiper.autoplay.stop();
          setStopped(true);
        }
      });

      // Hold still while keyboard focus is inside the reviews or their arrows.
      // Not the pause button itself: pressing Play focuses it, and should play
      scope.addEventListener('focusin', function(e){
        if (!stopped && e.target !== pauseButton) swiper.autoplay.pause();
      });
      scope.addEventListener('focusout', function(e){
        if (!stopped && !scope.contains(e.relatedTarget)) swiper.autoplay.resume();
      });
    });
  });
